import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import Swal from 'sweetalert2';

import withModalView from 'components/ui/withModalView';
import withContentLoader from 'components/ui/withContentLoader';
import How2Install from 'components/explore/How2Install';

import BotApi from 'api/bot';
import NotificationHelper from 'helpers/NotificationHelper';
import RequestBotHelper from 'helpers/RequestBotHelper';
import { useAuth } from 'providers/auth';

const AddBotPage = ({ data }) => {
  window.Swal = Swal;

  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [hiring, setHiring] = useState();
  const [isHired, setIsHired] = useState(data.companies.length > 0);
  const { me } = useAuth();

  const bot = data || {};
  bot.price = parseFloat(bot.price);

  const text_key = bot.price ? 'explore.add.paid' : 'explore.add.free';

  const handleRequestBot = async () => {
    setHiring(true);

    try {
      await RequestBotHelper.requestBot(bot, me);

      setIsHired(true);

      Swal.fire(
        'Robô solitado!',
        `Você solicitou o robô ${bot.name}. Por favor, aguarde que em breve nossa equipe irá entrar em contato com você.`,
        'success'
      );
    } catch (error) {
      console.error('ERROR', error);
      Swal.fire('Ops!', 'Ocorreu um erro ao solicitar a contratação.', 'error');
    } finally {
      setHiring(false);
    }
  };

  const handleFreeHire = async () => {
    setHiring(true);
    try {
      await BotApi.hire(bot.id);
      setIsHired(true);
      queryClient.invalidateQueries('explore_bot');

      Swal.fire({
        title: 'Robô contratado!',
        html: `<p>Você contratou o robô ${bot.name}. O mesmo já pode ser visto na página <a href="/bots">Meus robôs</a>. Siga as instruções para instalação e execução do robô <a href="#" onclick="window.Swal.closeModal(); return false;">aqui</a>.</p>`,
        icon: 'success',
      });
    } catch (error) {
      console.error(error);
      NotificationHelper.snack('Ocorreu um erro ao solicitar a contratação.');
    } finally {
      setHiring(false);
    }
  };

  const buttonAction = bot.price ? handleRequestBot : handleFreeHire;

  const button_free_text = isHired ? t('explore.add.button_add_free_hired') : t('explore.add.button_add_free');
  const button_paid_text = isHired ? t('explore.add.button_add_paid_hired') : t('explore.add.button_add_paid');
  const button_text_by_type = bot.price ? button_paid_text : button_free_text;
  const buttonText = !hiring ? button_text_by_type : t('keys.waiting');

  return (
    <div className="container">
      <div className="mb-2">{t('explore.add.title')}</div>
      <h3>{bot.name}</h3>

      <p>{t(text_key)}</p>

      <button disabled={hiring || isHired} className="btn btn-lg btn-primary mb-5" onClick={buttonAction}>
        {buttonText}
      </button>

      <hr />

      <How2Install />
    </div>
  );
};

const fetchData = async ({ routeMatch }) => {
  const { params } = routeMatch;
  return await BotApi.get(params.botId);
};

const page = withContentLoader(AddBotPage, { name: 'bot-add', fetchData });
export default withModalView(page);
